/**
 * KAN-862: совпадает ли медиа-запрос (с подпиской на изменение). Без
 * window.matchMedia (SSR, старые окружения) false.
 */
import { useCallback, useSyncExternalStore } from 'react';

function mediaList(query: string): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  return window.matchMedia(query) ?? null;
}

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = mediaList(query);
      if (!list) return () => undefined;
      if (typeof list.addEventListener === 'function') {
        list.addEventListener('change', onChange);
        return () => list.removeEventListener('change', onChange);
      }
      list.addListener?.(onChange);
      return () => list.removeListener?.(onChange);
    },
    [query]
  );
  const getSnapshot = () => mediaList(query)?.matches === true;
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
